module.exports = __webpack_public_path__ + "static/media/spe_designsystem_bg.9922944a.png";